import React from 'react';
import { Container, Title, Text } from '@mantine/core';
import SEO from '../Layout/seo';

const AboutUs: React.FC = () => {
	return (
		<div>
			<SEO
				title="About Scorpio Classics"
				description="Learn about Scorpio Classics, your trusted source for classic motorbikes, vintage jukeboxes, metal automobile signs, and memorabilia. Our passion drives our curated collections"
				keywords="jukeboxes, vintage, collectables, Scorpio Classics"
				imageUrl="https://www.scorpioclassics.com/images/top_slider/slider1.png"
				slug="/about-us"
			/>
			<Container
				size="lg"
				py="xl">
				<Title order={2}>About Us</Title>
				<Text mt="md">At Scorpio Classics, our passion for vintage collectibles and classic motorbikes is at the heart of everything we do. With years of experience, we have become a trusted source for enthusiasts and collectors seeking quality and authenticity.</Text>
				<Text mt="md">
					Born from the collaboration of two like-minded people, who for over 30
					years have shared the passion for rare and collectable motor vehicles,
					parts and memorabilia, Scorpio Classics aims to bring to the
					marketplace a great and diverse choice of interesting vehicles,
					automobilia and cool items from years gone by.
				</Text>
				<Text mt="md">
					We have a vast knowledge of historic Porsche & VW cars and can often
					find new and used parts for Speedster 356 (all models) and classic
					911s.
				</Text>
				<Text mt="md">
					Our love of motorcycles (especially 2-strokes) has given us the
					opportunity to offer some rare models for sale and we continue to seek
					out some very interesting stock.
				</Text>
				<Text mt="md">
					We hope you enjoy browsing our website and look forward to any phone
					calls or a visit to our site in Warwickshire.
				</Text>
			</Container>
		</div>
	);
};

export default AboutUs;
